import {useState} from 'react';
import type {AssetRecord} from '../shared/contracts';
import {assetUrl,useItems} from './api';
import {Field,Select} from './ui';
import {RetainedAssetPreview} from './RetainedAssetPreview';
export function IntakeSourcePreview({ids}:{ids:string[]}){
 const assets=useItems<AssetRecord>('assets'),[selected,setSelected]=useState('');
 const sources=(assets.data||[]).filter(a=>ids.includes(a.id));
 const source=sources.find(a=>a.id===selected)||sources[0];
 if(!ids.length)return null;
 return <details className="sales-disclosure intake-source-preview" open><summary>Read the original source</summary>{sources.length>1&&<Field label="Original to view"><Select value={source?.id||''} onChange={setSelected} options={sources.map(a=>({value:a.id,label:a.filename}))}/></Field>}{source&&<><RetainedAssetPreview key={source.id} asset={source} pdfFrame/><a href={assetUrl(source.id)} target="_blank" rel="noreferrer">Open {source.filename}</a></>}</details>;
}
